import React, { useContext } from 'react';

import { ImportTestCasesStatusContext } from '@qality/common-components/src/lib/ImportTestCasesStatusProvider';
import { StorageOfUniqueServices } from '@qality/common-service';

import { ImportSummaryView } from './ImportSummary.view';

export const ImportSummary = (): JSX.Element => {
  // @ts-expect-error ImportTestCasesStatusContext is in plain JS
  const { resetContext, errorMessages } = useContext(
    ImportTestCasesStatusContext
  );

  const importMore = (): void => {
    resetContext();
  };

  const exitImport = async (): Promise<void> => {
    const url = await StorageOfUniqueServices.get(
      'URLService'
    ).getTestCasesOverviewLink();
    StorageOfUniqueServices.get('AP').navigator.go('site', {
      absoluteUrl: url,
    });
  };

  return (
    <ImportSummaryView
      importMore={importMore}
      exitImport={exitImport}
      errorMessages={errorMessages}
    />
  );
};
